import { render, staticRenderFns } from "./navbar_form_pages.vue?vue&type=template&id=0482fcc7&scoped=true"
import script from "./navbar_form_pages.vue?vue&type=script&lang=js"
export * from "./navbar_form_pages.vue?vue&type=script&lang=js"
import style0 from "./navbar_form_pages.vue?vue&type=style&index=0&id=0482fcc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482fcc7",
  null
  
)

export default component.exports